export function googleAutoComplete(input, func)
{
  window.googleApis.Autocomplete().getPlacePredictions({ componentRestrictions: { country: 'es' }, input }, (predictions, status) => {
    let data = []

    if (status != 'OK') {
      func(data)
      return console.log(status)
    }

    predictions.forEach(prediction => {
      data.push({
        id: prediction.place_id,
        address: prediction.structured_formatting.main_text,
        info: prediction.structured_formatting.secondary_text
      })
    });
    
    func(data)
  });
}

export function googleDetails(placeId, func)
{
  window.googleApis.Places().getDetails({
    placeId,
    fields: ['address_component']
  }, ({ address_components }, status) => {

    let data = {}

    if (status != 'OK') {
      func(data)
      return console.log(status)
    }

    // 获取城市和邮编
    address_components.forEach(address => {
      // 数组类型
      let type = address.types[0]

      // 拿到地址
      if(type == 'route') {
        data.address = address.long_name
      }

      // 拿到城市
      if(type == 'locality') {
        data.city = address.long_name
      }
      // 拿到邮编
      if(type == 'postal_code') {
        data.code = address.long_name
      }
    });

    func(data)
  })
}